__turbopack_context__.v({
  "gradientLoadingText": "xDR07W_gradientLoadingText",
  "overlay": "xDR07W_overlay",
});
